import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../shared/form/_Button';
import Modal from '../../../shared/_Modal';
import { cancelSubscription, renewSubscription } from '../../../../actions/PaymentDetailsActions';
import { tooltipHide } from '../../../../actions/tooltipActions';

class ConfirmCancelModal extends React.Component {
    _handleSubscriptionAction = () => {
      const { subscriptionRenew, subscriptionCancel, type } = this.props;

      if (type === 'cancel') {
        subscriptionCancel();
      } else {
        subscriptionRenew();
      }
    };

    _handleHideModal = () => {
      const { hideTooltip, id } = this.props;

      hideTooltip(id);
    };

    componentWillUnmount() {
      this._handleHideModal();
    }

    render() {
      const { id, type, loading } = this.props;

      return (
        <Modal id={ id }>
          <div className='modal__header'>
          Are you sure?
          </div>
          <div>
          Are you sure you want to {type} your subscription?
          </div>

          <div className='modal__actions'>
            <Button className='form__button form__button--purple' loading={ loading } onClick={ this._handleSubscriptionAction } type='button'>Yes</Button>
            <Button className='form__button form__button--green' disabled={ loading } onClick={ this._handleHideModal } type='button'>No</Button>
          </div>
        </Modal>
      );
    }
}

ConfirmCancelModal.propTypes = {
  hideTooltip: PropTypes.func.isRequired,
  id: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  subscriptionCancel: PropTypes.func.isRequired,
  subscriptionRenew: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
  return {
    loading: state.getIn(['paymentDetails', 'loading'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    subscriptionRenew: () => dispatch(renewSubscription()),
    subscriptionCancel: () => dispatch(cancelSubscription()),
    hideTooltip: (id) => dispatch(tooltipHide({ id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmCancelModal);



// WEBPACK FOOTER //
// ./app/components/reps/settings/subscription/_ConfirmCancelModal.jsx